import { curriculumAuthHeader, handleResponse, handleError } from '../helper';
import CurriculumAPIHelper from '../common/CurriculumApiHelper';
import APIURLConstants from "../common/ApiURLConstants";


export const contentgalleryService = {
    getAllContentGallery,
    addContentGallery,
    getContentGalleryURL
};

function getAllContentGallery(data) {
    return CurriculumAPIHelper.post(APIURLConstants.GET_ALL_CONTENT_GALLERY, data, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function addContentGallery(data,type) {
    return CurriculumAPIHelper.post(APIURLConstants.SAVE_CONTENT_GALLERY, data, curriculumAuthHeader(type))
        .then(data => {
            return data;
        }).catch(handleError);
}

function getContentGalleryURL(data) {
    return CurriculumAPIHelper.get(APIURLConstants.GET_CONTENT_GALLERY_URL(data), curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}
